import useInterventionRepository from "../../../../../../repository/emergency/useInterventionRepository";
import {useEffect, useState} from "react";
import isNull from "../../../../../../mixin/isNull";
import {Table, TableBody, TableCell, TableHead, TableRow} from "@mui/material";
import useHelper from "../../../../../../use/useHelper";
import Typography from "@mui/material/Typography";

export default function ({interventionId, title = "Éléments présents sur le devis :"}) {
    const helper = useHelper();
    const interventionRepository = useInterventionRepository();
    const [items, setItems] = useState(null);

    useEffect(() => {
        fetch();
    }, []);

    const fetch = async () => setItems((await interventionRepository.getClientInvoiceDetails(interventionId)));

    if (isNull(items)) return null;

    return (
        <>
            <Typography fontWeight={"bold"}>
                {title}
            </Typography>
            <Table size="small" data-test="client-invoice-details">
                <TableHead>
                    <TableRow>
                        <TableCell>Nom</TableCell>
                        <TableCell>Qté</TableCell>
                        <TableCell>HT</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        items.map((item, index) => (
                            <TableRow key={index}>
                                <TableCell width={"60%"}>
                                    <Typography fontSize="small">
                                        {item.name}
                                    </Typography>
                                </TableCell>
                                <TableCell width={"15%"}>{helper.priceFormatter(item.quantity)}</TableCell>
                                <TableCell width={"25%"}>{helper.priceFormatter(item.price)} €</TableCell>
                            </TableRow>
                        ))
                    }
                </TableBody>
            </Table>
        </>
    )
}